// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"294":"836eecaa","473":"53a2a8ae","535":"0bd3c1ec","794":"d12e861a"}[chunkId] + ".css";
};